__turbopack_context__.v({
  "button": "Button-module__8cr-Ka__button",
  "fullWidth": "Button-module__8cr-Ka__fullWidth",
  "ghost": "Button-module__8cr-Ka__ghost",
  "iconRight": "Button-module__8cr-Ka__iconRight",
  "outlined": "Button-module__8cr-Ka__outlined",
  "small": "Button-module__8cr-Ka__small",
});
